var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "消息编辑",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "temppramRef",
              attrs: { "label-width": "120px", model: _vm.pram },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "模板名称：",
                    prop: "templateName",
                    rules: [
                      {
                        required: true,
                        message: "请填写模板名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写模板名称" },
                    model: {
                      value: _vm.pram.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "templateName", $$v)
                      },
                      expression: "pram.templateName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "说明：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "说明",
                    },
                    model: {
                      value: _vm.pram.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "description", $$v)
                      },
                      expression: "pram.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.tempSettingActive,
                        callback: function ($$v) {
                          _vm.tempSettingActive = $$v
                        },
                        expression: "tempSettingActive",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "站内信", name: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "短信通知", name: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "微信服务通知", name: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "飞书服务通知", name: "4" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "邮件通知", name: "5" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.tempSettingActive == "1"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知模版：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "通知模版",
                          },
                          model: {
                            value: _vm.stationLetter.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.stationLetter, "content", $$v)
                            },
                            expression: "stationLetter.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.stationLetter.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.stationLetter, "enabled", $$v)
                              },
                              expression: "stationLetter.enabled",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("开启"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.tempSettingActive == "2"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "腾讯云模板Code：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入腾讯云短信模板Code",
                          },
                          model: {
                            value: _vm.sms.tencent_template_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.sms, "tencent_template_code", $$v)
                            },
                            expression: "sms.tencent_template_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "腾讯云模板内容：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder:
                              "请输入腾讯云模板内容，例如：您的福豆在{1}时收入{2}",
                          },
                          model: {
                            value: _vm.sms.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.sms, "content", $$v)
                            },
                            expression: "sms.content",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tip" }, [
                          _vm._v(
                            "请与腾讯云后台模板保持一致，变量使用 {1}、{2} 数字格式。"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "阿里云模板Code：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入阿里云短信模板Code",
                          },
                          model: {
                            value: _vm.sms.aliyun_template_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.sms, "aliyun_template_code", $$v)
                            },
                            expression: "sms.aliyun_template_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "阿里云模板内容：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder:
                              "请输入阿里云模板内容，例如：您的福豆在${time}时收入${integral}",
                          },
                          model: {
                            value: _vm.sms.aliyun_content,
                            callback: function ($$v) {
                              _vm.$set(_vm.sms, "aliyun_content", $$v)
                            },
                            expression: "sms.aliyun_content",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tip" }, [
                          _vm._v(
                            "请与阿里云后台模板保持一致，变量使用 ${英文变量名} 格式。"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.sms.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.sms, "enabled", $$v)
                              },
                              expression: "sms.enabled",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("开启"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.tempSettingActive == "3"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "模版ID：" } },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "模版ID" },
                          model: {
                            value: _vm.wechat.template_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.wechat, "template_id", $$v)
                            },
                            expression: "wechat.template_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "模版编号：" } },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "模版编号" },
                          model: {
                            value: _vm.wechat.template_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.wechat, "template_code", $$v)
                            },
                            expression: "wechat.template_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知模版：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "通知模版",
                          },
                          model: {
                            value: _vm.wechat.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.wechat, "content", $$v)
                            },
                            expression: "wechat.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.wechat.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.wechat, "enabled", $$v)
                              },
                              expression: "wechat.enabled",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("开启"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.tempSettingActive == "4"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知模版：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "通知模版",
                          },
                          model: {
                            value: _vm.lark.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.lark, "content", $$v)
                            },
                            expression: "lark.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.lark.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.lark, "enabled", $$v)
                              },
                              expression: "lark.enabled",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("开启"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.tempSettingActive == "5"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知模版：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "通知模版",
                          },
                          model: {
                            value: _vm.email.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.email, "content", $$v)
                            },
                            expression: "email.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.email.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.email, "enabled", $$v)
                              },
                              expression: "email.enabled",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("开启"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }